import axios from "axios";
import { normalizeFeed, normalizeListing } from "./normalize";
import brandLogo from "../assets/brand/logo-re-tagdada.webp";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const fetchListings = async (limit = 200, offset = 0) => {
  const { data } = await axios.get(`${API}/listings`, { params: { limit, offset } });
  return normalizeFeed(data); // { count, limit, offset, items(normalized), source }
};

export const fetchListing = async (id) => {
  const { data } = await axios.get(`${API}/listings/${id}`);
  return normalizeListing(data);
};

export const fetchInfoLine = async () => {
  const { data } = await axios.get(`${API}/info-line`);
  return data; // { messages: string[], source }
};

export const BRAND = {
  logo: brandLogo,
  account: "https://tagdada.com",
  register: "https://tagdada.com/register",
  login: "https://tagdada.com/login",
};
